// Portfolio
import React, { useState } from 'react';
import { CreatorPortfolio } from 'types/creator';
import { MediaItem } from 'types/content';
import EditPortfolioModal from './EditPortfolioModal';
import {
  addPortfolioItem,
  removePortfolioItem,
  updatePortfolioItem,
} from 'api/creator';
import { trackEvent } from 'services/analytics';
import { CreatorProfileType } from 'types/profile';
import Portfolio from 'components/views/PublicProfile/Portfolio';

export interface PortfolioProps {
  creatorId: string;
  initialPortfolio: CreatorPortfolio;
  creatorName: string;
  profilePicture: string;
  profileType: CreatorProfileType;
}

const PersonalPortfolio: React.FC<PortfolioProps> = ({
  creatorId,
  initialPortfolio,
  creatorName,
  profilePicture,
  profileType,
}) => {
  const [portfolio, setPortfolio] = useState(initialPortfolio);
  const [addMediaOpen, setAddMediaOpen] = useState(false);
  const [editMedia, setEditMedia] = useState<MediaItem | undefined>();
  const [updatingPortfolio, setUpdatingPortfolio] = useState(false);

  const openAddMedia = () => {
    setAddMediaOpen(true);
  };

  const handleClose = () => {
    setEditMedia(undefined);
    setAddMediaOpen(false);
  };

  const editItem = (mediaItem: MediaItem) => {
    setEditMedia(mediaItem);
    trackEvent('Creator Opens Edit Portfolio Item Modal');
  };

  const removeItem = (mediaItem: MediaItem) => {
    handleClose();
    setUpdatingPortfolio(true);
    const confirmRemove = window.confirm('remove item?');
    if (confirmRemove && typeof mediaItem !== 'undefined') {
      removePortfolioItem(mediaItem).then((res) => {
        trackEvent('Creator Removes Portfolio Item', {
          ...mediaItem,
        });
        setPortfolio(res);
        setUpdatingPortfolio(false);
      });
    } else {
      setUpdatingPortfolio(false);
    }
  };

  const handleUpdateItem = (updatedMedia: MediaItem) => {
    handleClose();
    setUpdatingPortfolio(true);
    updatePortfolioItem(updatedMedia).then((res) => {
      trackEvent('Creator Updates Portfolio Item', {
        ...updatedMedia,
      });
      setPortfolio(res);
      setUpdatingPortfolio(false);
    });
  };

  const handleAddItem = (newMedia: MediaItem) => {
    handleClose();
    setUpdatingPortfolio(true);
    addPortfolioItem(newMedia).then((res) => {
      trackEvent('Creator Adds Portfolio Item', {
        ...newMedia,
      });
      setPortfolio(res);
      setUpdatingPortfolio(false);
    });
  };

  return (
    <>
      <Portfolio
        portfolio={portfolio}
        creatorId={creatorId}
        creatorName={creatorName}
        profilePicture={profilePicture}
        profileType={profileType}
        editItem={editItem}
        removeItem={removeItem}
        handleAddContent={openAddMedia}
        updatingPortfolio={updatingPortfolio}
      />
      {profileType === 'personal' && typeof editMedia !== 'undefined' && (
        <EditPortfolioModal
          type="update-content"
          initialMedia={editMedia}
          open={typeof editMedia !== 'undefined'}
          onClose={handleClose}
          handleUpdate={handleUpdateItem}
        />
      )}
      {profileType === 'personal' && (
        <EditPortfolioModal
          type="new-content"
          open={addMediaOpen}
          onClose={handleClose}
          handleSave={handleAddItem}
        />
      )}
    </>
  );
};

export default PersonalPortfolio;
